export default __webpack_public_path__ + "media/images/icons_fc/paperclip-0c1ac2233d58856b0b64118b8cc4436d.png";